import { type CountryFlagGlyph, IconCountryFlag } from '@sunwebgroup/uds-ui/icon-country-flag'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import cn from 'classnames'
import styles from './ReviewerInfo.module.css'

interface ReviewerInfoProps {
  flagCode?: CountryFlagGlyph
  reviewerName?: string
  partyCompositionLabel?: string
  isBigWrapper?: boolean
}

export default function ReviewerInfo({ flagCode, reviewerName, partyCompositionLabel, isBigWrapper }: ReviewerInfoProps) {
  return (
    <div className={styles.wrapper}>
      {flagCode && <IconCountryFlag glyph={flagCode} size={18} />}
      <div className={cn(styles.labelWrapper, isBigWrapper && styles.labelWrapperBig)}>
        {reviewerName && <Typography className={styles.reviewerName}>{reviewerName}</Typography>}
        {partyCompositionLabel && <Typography className={styles.reviewerType}>{partyCompositionLabel}</Typography>}
      </div>
    </div>
  )
}
